module.exports = __webpack_public_path__ + "static/media/social-buddy-2.b8c8b85b.png";